import React, { useState, useEffect } from 'react'
import { isNilOrEmpty, useDebounce } from 'packages/core'
import { Paper, styled, Box } from '@mui/material'
import { Icon } from 'packages/eid-icons'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { ThresholdSearchInput } from 'packages/eid-ui'

const StyledPaper = styled(Paper)(({ theme, outlined }) => ({
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    backgroundColor: '#ffffff !important',
    boxShadow: outlined
        ? 'none !important'
        : '0 4px 6px -2px rgba(0, 0, 0, 0.1)',
    border: outlined ? 'solid 1px #d8d8dd' : 'solid 1px #ebebed',
    borderRadius: outlined ? '3px' : '5px',
    padding: outlined ? '0px 0px 0px 10px' : '2px 4px',
    height: outlined ? 'initial' : '40px',
    fontSize: outlined ? '13px' : 'initial',
    '& div:nth-child(1)': {
        boxShadow:'none !important',
        border:'none !important',
        height:'auto !important', 
    },
    '& .MuiInputBase-input': {
        fontSize: outlined ? '13px !important' : 'initial',
    },
    '&:hover': {
        border: outlined
            ? `1px solid ${theme?.palette?.primary?.main}`
            : 'initial',
    },
    '&:focus-within': {
        border: outlined
            ? `1px solid ${theme?.palette?.primary?.main}`
            : 'initial',
        boxShadow: outlined
            ? '0 4px 8px 0 rgba(48, 127, 193, 0.33)'
            : 'initial',
    },
}))

const StyledIcon = styled(Icon)({
    width: 19,
    height: 19,
    marginLeft: 17,
})

const StyledClearIcon = styled(Icon)({
    margin: '0px 10px !important',
    '&:hover': {
        cursor: 'pointer',
    },
})

const Search = (props) => {
    const { handleSearch, handleClear, placeholder, value, outlined } = props
    const { t } = useTranslation()
    const [searchKey, setSearchKey] = useState(value)
    const [, dispatch] = usePageContext()

    useEffect(() => {
        if (value !== searchKey) {
            setSearchKey(value)
        }
    }, [value])

    const handleChange = (eventOrValue) => {
        const keyword = eventOrValue?.target?.value ?? eventOrValue
        setSearchKey(keyword)
        dispatch({
            type: 'SET_PAGE',
            payload: 1,
        })
    }
    const handleClearSearch = () => {
        setSearchKey('')
        handleClear('')
        dispatch({
            type: 'SET_PAGE',
            payload: 1,
        })
    }
    const debouncedValue = useDebounce(searchKey)

    useEffect(() => {
        handleSearch(debouncedValue)
    }, [debouncedValue])

    return (
        <StyledPaper outlined={outlined}>
            <StyledIcon name="Search" color="#D8D8DD" />

            <Box position="relative" >
                <ThresholdSearchInput
                    value={searchKey}
                    handleSearch={handleChange}
                    placeholder={t('Search')}
                    sx={{
                        borderColor: '#000000',
                        '& > input': {
                            width: '100%',
                            height: '10px',
                            border: 'none',
                            boxShadow: 'none !important',
                        },
                    }}
                    sxNotify={{ position: 'absolute', top: '-33px' }}
                />
            </Box>
            {!isNilOrEmpty(searchKey) && (
                <StyledClearIcon
                    name="Close"
                    color="#D8D8DD"
                    onClick={handleClearSearch}
                />
            )}
        </StyledPaper>
    )
}

export default Search
